import { useMemo } from 'react';

import PropTypes from 'prop-types';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import MenuItem from '../MenuItem';

import {
  MenuStyle,
  MenuListStyle,
  FormControlStyled,
  InputLabelStyled,
  SelectStyled
} from './styles';

export default function SelectInput({
  Id,
  label,
  value,
  disabled,
  minWidth,
  options,
  bordered = false,
  boldValues = ['', 'all', '30'],
  disableAllOptions = false,
  handleChange,
  handleClick
}) {
  const isBold = useMemo(() => boldValues.some((v) => v === value), [boldValues, value]);
  const onCloseDropdown = () => {
    setTimeout(() => {
      document.activeElement.blur();
    }, 0);
  };

  return (
    <FormControlStyled
      bordered={bordered}
      disabled={disabled}
      size="small"
      sx={{ minWidth }}
    >
      {!value && (
        <InputLabelStyled
          color="primary"
          disabled={disabled}
          id={`${Id}-label`}
        >
          {label}
        </InputLabelStyled>
      )}
      <SelectStyled
        bordered={bordered}
        data-testid="select-input"
        disabled={disabled}
        IconComponent={KeyboardArrowDownIcon}
        id={Id}
        label={value ? '' : label}
        labelId={`${Id}-label`}
        MenuProps={{
          sx: MenuStyle,
          MenuListProps: {
            sx: MenuListStyle
          }
        }}
        onChange={handleChange}
        onClose={onCloseDropdown}
        onOpen={handleClick}
        value={value}
      >
        {options.map(({ key, name }) => (
          <MenuItem
            disabled={disableAllOptions}
            isBold={isBold}
            key={key}
            selected
            value={key}
          >
            {name}
          </MenuItem>
        ))}
      </SelectStyled>
    </FormControlStyled>
  );
}

SelectInput.propTypes = {
  Id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bordered: PropTypes.bool,
  boldValues: PropTypes.arrayOf(PropTypes.string),
  disableAllOptions: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  handleClick: PropTypes.func
};
